
    const data = {"name":"src/core/icons/calendar-plus","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19V8H5v11h14M16 1h2v2h1a2 2 0 0 1 2 2v14c0 1.11-.89 2-2 2H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1m-5 8.5h2v3h3v2h-3v3h-2v-3H8v-2h3v-3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            